import styled from '../styled';

export const UnderlinedA = styled('a')`
  border-bottom: 1px solid ${(p) => p.theme.palette.grey[400]};
`;
